import React, { useState } from 'react';
import LandingContainer from '../LandingContainer';

export default function FaqSection({ items }) {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="bg-neutral-50 py-12 xs:py-14 sm:py-24">
      <LandingContainer>
        <div className="mx-auto max-w-3xl">
          <p className="mb-3 text-[11px] font-semibold uppercase tracking-[0.14em] text-primary-700 sm:text-xs sm:tracking-[0.18em]">
            FAQ
          </p>
          <h2 className="font-heading text-2xl font-bold tracking-tight text-charcoal-900 sm:text-4xl">
            Questions people ask before connecting a form
          </h2>
          <div className="mt-8 divide-y divide-neutral-200 overflow-hidden rounded-3xl border border-neutral-200 bg-white">
            {items.map((item, index) => {
              const open = openIndex === index;
              return (
                <div key={item.question}>
                  <button
                    type="button"
                    className="flex w-full items-start justify-between gap-4 px-4 py-4 text-left sm:px-6"
                    aria-expanded={open}
                    onClick={() => setOpenIndex(open ? -1 : index)}
                  >
                    <span className="font-heading text-base font-semibold text-charcoal-900 sm:text-lg">
                      {item.question}
                    </span>
                    <span className="mt-0.5 shrink-0 text-charcoal-500" aria-hidden>
                      {open ? '−' : '+'}
                    </span>
                  </button>
                  {open && (
                    <p className="px-4 pb-4 text-sm leading-6 text-charcoal-600 sm:px-6 sm:text-base sm:leading-7">
                      {item.answer}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </LandingContainer>
    </section>
  );
}
